import CommonSelector from "@components/global/new/CommonSelector/CommonSelector";
import { useIntl } from "react-intl";
import useContractPlanSelectorControl from "./ContractPlanSelector.control";
import { useCallback, useEffect, useRef, useState } from "react";
import decodeHTMLEntities from "@utils/decodeHTMLEntities";


export interface ContractPlanOnChangeParams {
  contractId?: number,
  planId?: number,
  prevPlanId?: number,
}

export interface ContractPlanSelectorProps {
  readonly id: string;
  readonly contractId?: number;
  readonly planId?: number;
  onChange: (params: ContractPlanOnChangeParams) => void;
}

export function ContractPlanSelect(
  props: ContractPlanSelectorProps
): JSX.Element {

  const { formatMessage } = useIntl();
  const control = useContractPlanSelectorControl(props);

  return (
    <>
      <CommonSelector
        id={props.id}
        name={formatMessage({
          id: "machines.more.settings.select_contract.label",
        })}
        options={control.contracts.map((c) => ({
          ...c,
          text: decodeHTMLEntities(c.text),
        }))}
        onChange={control.onContractChanged}
        hasCleanUp={true}
        currentValue={control.state.currentContractValue}
        onCleanUp={() => {
          control.onContractChanged(-1);
          control.clearContract();
        }}
      />
      <CommonSelector
        id="miner_plan"
        disabled={
          !control.state.currentContractId ||
          control.state.currentContractId === -1
        }
        disabledHint={formatMessage({
          id: "machines.more.settings.select_plan.disabled_hint",
        })}
        name={formatMessage({
          id: "machines.more.settings.select_plan.label"
        })}
        options={control.state.plans.map((p) => ({
          id: p.id,
          text: decodeHTMLEntities(p.name),
        }))}
        currentValue={
          control.state.currentContractId === -1
            ? undefined
            : control.state.currentPlanValue
        }
        hasCleanUp={true}
        onCleanUp={control.clearPlan}
        onChange={control.onPlanChanged}
      />
    </>
  );
}
